import {httpClient} from './index';

/**
 * 获取回测数据, 准备审查
 * @param canteenId
 * @param dateRange
 * @param username
 * @returns {Promise$1|PromiseObj|Promise$1|PromiseObj|PromiseLike<T | never>|Promise<T | never>|*}
 * @private
 */
export const _getBackData = ({
  canteenId,
  dateRange,
  username,
  label_task_uuid
}) => {
  return httpClient
    .post(`back_data/query`, {
      canteen_id: canteenId,
      collect_time_range: dateRange,
      username,
      label_task_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
// 获取采集数据, 准备审查
export const _getDetectedImage = ({
  canteenId,
  dateRange,
  username,
  label_task_uuid
}) => {
  return httpClient
    .post(`data_collect/query `, {
      canteen_id: canteenId,
      collect_time_range: dateRange,
      username,
      label_task_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
/**
 * 审查采集数据
 * @param checked
 * @param class_id
 * @param discard_img_uuid_list
 * @param apiKey
 * @returns {Promise$1|PromiseObj|Promise$1|PromiseObj|PromiseLike<T | never>|Promise<T | never>|*}
 * @private
 */
export const _checkDetectedImage = ({
  checked,
  class_id,
  discard_img_uuid_list = [],
  dish_img_uuid_list,
  apiKey,
  label_task_uuid,
  is_finish
}) => {
  return httpClient
    .post(
      `data_collect/check`,
      {
        class_id,
        discard_img_uuid_list,
        dish_img_uuid_list,
        checked,
        label_task_uuid,
        is_finish
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
/**
 * @param label_info_list 标注使用, 标注后的列表, 删除class_id = -1
 * @param apiKey
 * @param checked_class_list 可选, 无意义
 * @param dish_img_uuid_list 可选, 用于改变碗碟的审查状态, new_task的时候不用传递
 * @param new_task 默认false, new_task为true
 * @returns {Promise$1|PromiseObj|Promise$1|PromiseObj|PromiseLike<T | never>|Promise<T | never>|*}
 * @private
 */
export const _backDataMark = (
  label_info_list,
  apiKey,
  checked_class_list = [],
  dish_img_uuid_list = [],
  new_task = false,
  label_task_uuid
) => {
  console.log(label_task_uuid);
  return httpClient
    .post(
      `back_data/mark`,
      {
        label_info_list,
        checked_class_list,
        dish_img_uuid_list,
        new_task,
        label_task_uuid
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(true);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _backDataAccSave = ({
  canteen_id,
  label_data_list,
  apiKey,
  date_ts
}) => {
  return httpClient
    .post(
      `back_data/acc/save`,
      {
        canteen_id,
        label_data_list,
        date_ts
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getBackDataAcc = ({ canteen_id, date_ts, apiKey }) => {
  return httpClient
    .post(
      `back_data/acc/query`,
      { canteen_id, date_ts },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _detectedCheckRemind = (apiKey, date_range, refresh = true) => {
  console.log(apiKey);
  return httpClient
    .post(
      `data_collect/check_remind`,
      {
        date_range,
        refresh
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};

export const _backDataCheckRemind = (apiKey, date_range, refresh = true) => {
  return httpClient
    .post(
      `back_data/check_remind`,
      {
        date_range,
        refresh
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _dateCollectCheckRemind = (apiKey, date_range, refresh = true) => {
  console.log(refresh);
  return httpClient
    .post(
      `data_collect/label_remind`,
      {
        date_range,
        refresh
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getResentlyAcc = ({ acc_line, recently_days, end_day_ts }) => {
  return httpClient
    .post(`back_data/acc/recently_query`,
      { acc_line, recently_days, end_day_ts })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getAccByCanteen = (canteen_id, day_ts) => {
  return httpClient.post(`back_data/acc/calculate`,
    {
      canteen_id,
      day_ts
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getLabelTaskidByBar = ({canteen_id, day_ts, class_id}) => {
  return httpClient.post(`label_task/by_dish_canteen_query`,
    {canteen_id, day_ts, class_id}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
